import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { templatesApi } from '../api/templates';
import Spinner from '../components/ui/Spinner';
import TemplateRenderer from '../templates/TemplateRenderer';
import { getDemoPhotos, DEMO_PHOTOS } from '../templates/shared/demoPhotos'; // <-- Importar fotos demo

// Datos demo por slug
const DEMO_DATA = {
  'boda-clasica': {
    bride: 'María Fernanda',
    groom: 'Carlos Andrés',
    date: '2026-12-12',
    time: '6:00 PM',
    civilPlace: 'Municipalidad de Arequipa',
    civilAddress: 'Calle San Agustín 100',
    civilTime: '4:00 PM',
    church: 'Catedral de Arequipa',
    churchAddress: 'Plaza de Armas s/n',
    churchTime: '6:00 PM',
    place: 'Hacienda San José',
    address: 'Km 12 Vía Yura',
    receptionTime: '8:00 PM',
    verse: 'El amor es paciente, es bondadoso; todo lo cree, todo lo espera, todo lo soporta.',
    verseRef: '1 Corintios 13:4-7',
    story: 'Nos conocimos en el verano de 2018 en una playa del sur. Lo que comenzó como una amistad se convirtió en el amor de nuestras vidas. Después de 6 años juntos, decidimos dar el siguiente paso y celebrar nuestro amor con quienes más queremos.',
    description: 'Su presencia hará este día aún más especial. Nos encantaría contar con ustedes en la celebración de nuestra unión.',
    dressCode: 'Formal / Etiqueta',
    giftRegistry: 'https://ejemplo.com/mesa-de-regalos',
    hashtag: '#MariaYCarlos2026',
    notes: 'Favor de confirmar asistencia antes del 1 de diciembre.',
  },
  'boda-elegante': {
    bride: 'Sofía',
    groom: 'Andrés',
    date: '2026-11-08',
    time: '7:00 PM',
    civilPlace: 'Municipalidad de Miraflores',
    civilAddress: 'Av. Larco 400, Lima',
    civilTime: '4:30 PM',
    church: 'Iglesia La Recoleta',
    churchAddress: 'Plaza Francia, Lima',
    churchTime: '7:00 PM',
    place: 'Hotel Belmond Miraflores Park',
    address: 'Av. Malecón de la Reserva 1035',
    receptionTime: '9:00 PM',
    verse: 'El amor es paciente, es bondadoso; todo lo cree, todo lo espera, todo lo soporta.',
    verseRef: '1 Corintios 13:4-7',
    story: 'Nos conocimos en el 2019 en una cena de amigos. Lo que empezó como una conversación casual se transformó en la relación más importante de nuestras vidas. Después de 7 años juntos, decidimos unir nuestras vidas para siempre.',
    description: 'Gracias por acompañarnos en este momento único. Su presencia hace este día aún más especial.',
    dressCode: 'Black Tie',
    giftRegistry: 'https://ejemplo.com/mesa-regalos',
    hashtag: '#SofiaYAndres2026',
    notes: 'Favor confirmar antes del 1 de noviembre. No niños.',
  },
  'boda-boho': {
    bride: 'Lucía',
    groom: 'Mateo',
    date: '2026-10-25',
    time: '6:00 PM',
    civilPlace: 'Casa de campo Los Almendros',
    civilAddress: 'Valle de Yura, Arequipa',
    civilTime: '5:00 PM',
    church: 'Parroquia del Sagrario',
    churchAddress: 'Calle Bolívar s/n',
    churchTime: '7:00 PM',
    place: 'Hacienda Mollebaya',
    address: 'Km 8 Vía Mollebaya',
    receptionTime: '9:00 PM',
    verse: 'El amor no consiste en mirarse el uno al otro, sino en mirar juntos en la misma dirección.',
    verseRef: 'Antoine de Saint-Exupéry',
    story: 'Nos conocimos en un viaje a Cusco en 2018. Entre caminatas, atardeceres y mates de coca, descubrimos que queríamos seguir explorando el mundo juntos. Después de 8 años de aventuras, decidimos echar raíces en un mismo hogar.',
    description: 'Celebra con nosotros este momento tan especial. Ven con ropa cómoda y muchas ganas de bailar bajo las estrellas.',
    dressCode: 'Formal Boho',
    giftRegistry: 'https://ejemplo.com/mesa-boho',
    hashtag: '#LuciaYMateo',
    notes: 'Boda al aire libre. Trae una manta o chal para la noche.',
  },
  'cumple-infantil': {
    name: 'Sofía', age: 5,
    date: '2026-11-20', time: '3:00 PM',
    place: 'Salón Mágico',
    address: 'Calle Los Sueños 456',
    description: '¡Ven a celebrar con nosotros! Habrá sorpresas y mucha diversión.',
  },
  'baby-shower-azul': {
    babyName: 'Mateo', parents: 'Ana y Luis',
    date: '2026-10-15', time: '5:00 PM',
    place: 'Casa de la familia',
    address: 'Jr. Las Flores 789',
    description: 'Esperamos compartir este momento tan especial contigo.',
  },
  'bautizo-dorado': {
    child: 'Isabella',
    date: '2026-11-08',
    time: '11:00 AM',
    church: 'Parroquia San Pedro',
    churchAddress: 'Plaza de Armas s/n, Arequipa',
    place: 'Hacienda Los Olivos',
    address: 'Av. Los Álamos 456, Arequipa',
    verse: 'Dejad a los niños venir a mí, y no se lo impidáis; porque de los tales es el reino de los cielos.',
    verseRef: 'Mateo 19:14',
    description: 'Con mucha alegría te invitamos a compartir el día en que nuestra hija recibirá el sacramento del bautismo.',
    dressCode: 'Formal / Vestimenta clara',
    notes: 'La ceremonia comenzará puntualmente. Te pedimos llegar 15 minutos antes.',
    godparents: [
      { name: 'Ana García', role: 'Madrina' },
      { name: 'Carlos Mendoza', role: 'Padrino' },
    ],
  },
  'graduacion-moderna': {
    graduate: 'Diego Ramírez', career: 'Ingeniería de Sistemas',
    date: '2026-12-20', time: '8:00 PM',
    place: 'Centro de Convenciones',
    address: 'Av. Universitaria 1000',
    description: 'El fin de una etapa, el comienzo de un gran futuro.',
  },
};

export default function PreviewTemplate() {
  const { slug } = useParams();
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const t = await templatesApi.get(slug);
        setTemplate(t);
      } catch (err) {
        setError('Plantilla no encontrada');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center">
        <Spinner size="lg" className="text-brand-500" />
      </div>
    );
  }

  if (error || !template) {
    return (
      <div className="min-h-screen grid place-items-center px-4">
        <div className="text-center">
          <p className="text-5xl mb-3">😕</p>
          <p className="text-slate-500 mb-4">{error || 'Plantilla no encontrada'}</p>
          <Link to="/templates" className="text-brand-600 font-semibold hover:underline">
            Volver a plantillas
          </Link>
        </div>
      </div>
    );
  }

  const demoData = DEMO_DATA[slug] || {};
  
  // <-- Cover por defecto según la categoría del template
  const defaultCover = {
    url: DEMO_PHOTOS[template.category]?.[0]?.url || DEMO_PHOTOS.Matrimonios[0].url,
    alt: DEMO_PHOTOS[template.category]?.[0]?.alt || 'Portada del evento',
  };
  
  // <-- Media demo según la categoría
  const demoMedia = getDemoPhotos(template.category);

  return (
    <div className="relative">
      {/* Barra superior fija */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-slate-900/95 backdrop-blur text-white">
        <div className="max-w-6xl mx-auto px-4 h-14 flex items-center justify-between">
          <Link to="/templates" className="text-xs text-slate-300 hover:text-white">
            ← Volver a plantillas
          </Link>
          <p className="text-xs text-slate-400">
            Vista previa: <b className="text-white">{template.name}</b>
          </p>
          <Link
            to={`/events/new/${template.id}`}
            className="text-xs font-semibold bg-brand-500 hover:bg-brand-600 px-4 py-2 rounded-lg"
          >
            Usar esta plantilla
          </Link>
        </div>
      </div>

      <div className="pt-14">
        <TemplateRenderer
          template={template}
          data={demoData}
          title="Vista previa"
          cover={defaultCover}  // <-- Pasar cover por defecto
          media={demoMedia}      // <-- Pasar media demo
        />
      </div>
    </div>
  );
}